import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * Bootstraps the signed-in user from the existing session cookie.
 *
 * `GET /api/auth/me` answers 200 with `{ ok: false, authenticated: false }` when
 * there is no valid cookie (rather than a 401), so a rejected promise here means
 * a genuine failure, not "logged out".
 */
export function useAuth() {
  const [state, setState] = useState({ status: 'loading', user: null });

  useEffect(() => {
    const controller = new AbortController();

    api
      .get('/api/auth/me', { signal: controller.signal })
      .then((data) => setState({ status: 'ready', user: data?.user ?? null }))
      .catch((error) => {
        if (error.name === 'AbortError') return;
        // `ok:false` is the guest case; anything else is thrown as an ApiError.
        setState({ status: 'guest', user: null });
      });

    return () => controller.abort();
  }, []);

  return {
    ...state,
    isLoading: state.status === 'loading',
    isAuthenticated: state.status === 'ready' && Boolean(state.user),
  };
}
